import Interface from "../../../interfaces/Interfaceable.js";

const BreaksCenterListenerInterface = new Interface("SocketListener", [
	"connect",
	"schedule_break_request_approved",
	"schedule_break_request_rejected",
]);

export default BreaksCenterListenerInterface;
